export default __webpack_public_path__ + "static/media/GSP_Frame.523e86a6.png";